/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Setting_Group_PhoneInputs */

const en_enum_setting_group_phone = /** @type {(inputs: Enum_Setting_Group_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group Phone`)
};

const de_enum_setting_group_phone = /** @type {(inputs: Enum_Setting_Group_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppe Phone`)
};

/**
* | output |
* | --- |
* | "Group Phone" |
*
* @param {Enum_Setting_Group_PhoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_setting_group_phone = /** @type {((inputs?: Enum_Setting_Group_PhoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Setting_Group_PhoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_setting_group_phone(inputs)
	return de_enum_setting_group_phone(inputs)
});